<template>
  <div>
    <div id="container"></div>
  </div>
</template>
<script>
import markerIcon from "@/assets/markers/biaoji.svg";

export default {
  props: {},
  data() {
    return {
      map: null,
      readonly: false,
      marker: null,
    };
  },
  mounted() {
    this.createMap();
  },
  created() {},
  methods: {
    //1.创建map对象
    createMap() {
      //1.地图初始化时，在地图上添加marker标记,鼠标点击marker可弹出自定义的信息窗体
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        animateEnable: false,
        // mapStyle: 'amap://styles/light',
        mapStyle: "amap://styles/darkblue",
        // // showLabel: false,
        // features: ['bg', 'road', 'building'],
        center: [116.29920714, 39.681], //初始地图的中心点坐标
        zoom: 15,
      });

      this.addGeoJson("all", "#31aaff", true);

      // this.map.on("click", (e) => {
      //   this.mapClick(e);
      // });
    },
    addGeoJson(jsonName, color, isAll) {
      let geoJSON = require(`@/assets/geojson/${jsonName}.json`);
      // let geoJSON = require(jsonName);

      let geojson = new AMap.GeoJSON({
        geoJSON: geoJSON,
        // 还可以自定义getMarker和getPolyline
        getPolygon: function (geojson, lnglats) {
          // 计算面积
          return new AMap.Polygon({
            path: lnglats,
            fillOpacity: 0.2, // 面积越大透明度越高
            strokeColor: color,
            fillColor: color,
          });
        },
      });
      geojson.on("click", (e) => {
        this.mapClick(e);
      });

      this.geo = geojson;

      this.map.add(geojson);
    },

    mapClick(e) {
      if (this.readonly) {
        return;
      }
      const lnglat = [e.lnglat.getLng(), e.lnglat.getLat()];

      this.addPoint(lnglat, false);

      this.$emit("change", lnglat);
    },

    //2.添加点标记
    addPoint(lnglat, readonly) {
      this.readonly = readonly;

      // this.map.setCenter(lnglat);
      if (this.marker) this.map.remove(this.marker);

      const icon = new AMap.Icon({
        // size: new AMap.Size(33, 35), // 图标尺寸
        image: markerIcon, //require('@/assets/markers/zhongdian.svg'), // Icon的图像

        // imageOffset: new AMap.Pixel(0, -60), // 图像相对展示区域的偏移量，适于雪碧图等
        imageSize: new AMap.Size(33, 35), // 根据所设置的大小拉伸或压缩图片
      });

      // const position = [e.lnglat.getLng(), e.lnglat.getLat()]

      let marker = new AMap.Marker({
        icon, //点标记图片路径
        position: lnglat, //位置

        anchor: "bottom-center",
        // 设置是否可以拖拽
        draggable: false,
        cursor: "move",
        // 设置拖拽效果
        raiseOnDrag: false,
      });
      this.marker = marker;

      marker.setMap(this.map);

      // this.$emit('change', position)
    },
  },
};
</script>

<style scoped>
html,
body,
#container {
  height: 100%;
  width: 100%;
}

.content-window-card {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  /* width: auto; */
  width: 350px;
  padding: 0;
}

.content-window-card p {
  height: 2rem;
}

.custom-info {
  /* border: solid 1px silver; */
}

div.info-top {
  position: relative;
  background: none repeat scroll 0 0 #f9f9f9;
  border-bottom: 1px solid #ccc;
  border-radius: 5px 5px 0 0;
}

div.info-top div {
  display: inline-block;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px;
}

div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}

div.info-top img:hover {
  box-shadow: 0px 0px 5px #000;
}

div.info-middle {
  font-size: 12px;
  padding: 10px 6px;
  line-height: 20px;
}

div.info-bottom {
  height: 0px;
  width: 100%;
  clear: both;
  text-align: center;
}

div.info-bottom img {
  position: relative;
  z-index: 104;
}

/* span {
  margin-left: 5px;
  font-size: 11px;
} */

.info-middle img {
  float: left;
  margin-right: 6px;
}

.info-span {
  /* margin-left: 35px; */
  font-size: 11px;
}

.info-div {
  width: 140px;
  display: inline-block;
  margin-left: 10px;
}

.info-img {
  width: 40px;
  height: 40px;
}

.info-a-title {
  /* color: #000000; */
  font-size: 16px;
}

#container {
  height: 820px;
}

#container .amap-icon img,
.amap-marker-content img {
  width: 64px;
  height: 64px;
}
</style>